/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageCircle: {
  name: 'bubble-message-circle';
  data: string;
} = {
  name: 'bubble-message-circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 1 1 4.714 7.296 2.063 2.063 0 0 0-1.227-.153l-3.235.605.605-3.235c.081-.433.012-.86-.153-1.227A7.968 7.968 0 0 1 4 12Zm8-10C6.477 2 2 6.477 2 12c0 1.462.315 2.854.88 4.109a.09.09 0 0 1 .01.037l-.873 4.67a1 1 0 0 0 1.167 1.167l4.67-.874a.09.09 0 0 1 .037.01 9.969 9.969 0 0 0 4.11.881c5.522 0 10-4.477 10-10S17.522 2 12 2ZM9 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
